module.exports = __webpack_public_path__ + "static/media/ST3.4a5e6cb1.mp3";